// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__352ej","prefix":"style_prefix__1ALob","icon":"style_icon__1KkZJ"};